<!--电费账单-->
<template>
  <div style="height: 100%;background-color: white;">
    <div style="height: 100%;">
      <!--选择查询表单-->
      <div class="page_top_form">
        <el-form ref="form" label-width="90px">
          <el-form-item label="业主姓名">
            <el-input v-model="ownerName" placeholder="请输入业主名称" style="width:140px"></el-input>
          </el-form-item>
          <el-form-item label="抄表日期">
            <el-date-picker @change="getDataList" value-format="timestamp" size="small" v-model="datetimeValue"
              type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始时间"
              end-placeholder="结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="缴费状态">
            <el-select v-model="state" placeholder="请选择" style="height: 30px;width: 120px;">
              <el-option v-for="item in chargingStatusList" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="电表类型">
            <el-select v-model="meterRunType" placeholder="请选择" style="height: 30px;width: 120px;">
              <el-option v-for="item in meterRunTypeList" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="账单类型">
            <el-select v-model="accountType" placeholder="请选择" style="height: 30px;width: 120px;">
              <el-option v-for="item in accountTypeList" :key="item.value" :label="item.text" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary" size="mini" @click="getDataList">查询</el-button>
            <el-button type="primary" size="mini" @click="exportReport">账单导出</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="infoListContainer">
        <el-table :data="dataList" height="795" border style="width: 100%" v-loading="loading">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" width="90" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="userName" label="业主姓名">
          </el-table-column>
          <el-table-column prop="meterRunType" label="表类型" :formatter="editMeterRunType" width="70">
          </el-table-column>
          <el-table-column prop="accountType" label="付费类型" :formatter="editAccountType" width="120">
          </el-table-column>
          <el-table-column prop="Time" label="用电时间" width="252">
          </el-table-column>
          <el-table-column prop="beginMeterReading" label="上次抄表">
          </el-table-column>
          <el-table-column prop="endMeterReading" label="本次抄表">
          </el-table-column>
          <el-table-column prop="electricQuantity" label="用电量(kWh)">
          </el-table-column>
          <el-table-column prop="electricFee" label="电度电费(元)">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.electricFee) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deductionStandard" label="电费单价(元)">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.deductionStandard) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="amount" label="合计(元)">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.amount) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="minUserBalance" label="上次余额(元)">
            <template slot-scope="scope">

              <span>{{editMoneyYan(scope.row.maxUserBalance) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="maxUserBalance" label="本次余额(元)">
            <template slot-scope="scope">
              <span>{{editMoneyYan(scope.row.minUserBalance) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="operate" label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="viewOrderDetails(scope.row)" plain>账单详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <elPagination :total="totalSize" :pageSize="pageSize" @pageindexChange="pageindexChange"
          @handleSizeChange="handleSizeChange" />
      </div>
    </div>
    <billDialog ref="billDialog"></billDialog>
  </div>
</template>

<script>
  import infoListMultipleSelection from '@/page/system/meterReading/infoListMultipleSelection.vue'
  import singleSelection from '@/components/module/selection/singleSelection.vue'
  import OrderMeterDialog from './orderDetailListReport.vue'
  import billDialog from './billDialog.vue'
  import billStore from './orderDetailbillStore'
  import ownerManagerStore from "../system/meterReading/ownerManagerStore";
  import elPagination from "@/components/module/elComponents/elPagination.vue"
  export default {
    components: {
      infoListMultipleSelection,
      billDialog,
      singleSelection,
      elPagination,
    },
    props: {},
    data () {
      return {
        pageIndex: 1,
        pageSize: 20,
        totalSize: 0,
        dataList: [],
        deviceNos: '',
        ownerName: '',
        state: -1,
        filterTime: false,
        searchChange: false,
        accountType: 1,
        meterRunType: 2,
        meterType: "electric",
        billingMode: '',
        datetimeValue: [new Date().getTime()-3600*1000*24*31,new Date().getTime()],
        pickerOptions: {
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*7);
              picker.$emit('pick',[start,end]);
            }
          },{
            text: '最近三个月',
            onClick (picker) {
              const end=new Date(new Date().toLocaleDateString());
              const start=new Date(new Date().toLocaleDateString());
              start.setTime(start.getTime()-3600*1000*24*92);
              picker.$emit('pick',[start,end]);
            }
          }]
        },
        loading: false,
      }
    },
    created () {},
    mounted () {
      this.getDataList()
    },
    destroyed () {
      //页面销毁时强制关闭
      this.$store.cacheStore.state.load=false
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
      nowSelectDate () {
        return this.$store.cacheStore.getters.getNowSelectDate
      },
      nowTimeInterval () {
        return this.$store.cacheStore.getters.getBillTimeInterval
      },
      nowDateText () {
        return this.filterTime? this.nowTimeInterval.startDate.formatByDate()+' - '+this.nowTimeInterval.endDate.formatByDate():''
      },
      columns () {
        return billStore.state.columns
      },
      editOwnerName () {
        return userName => {
          return userName==null||userName==''||userName==undefined? '-':userName
        }
      },
      chargingStatusList () {
        return billStore.state.chargingStatusList
      },
      accountTypeList () {
        return billStore.state.accountTypeList
      },
      meterRunTypeList () {
        return billStore.state.meterRunTypeList
      },
      timeText () {
        return time => {
          if(time==null||time==undefined||time=='') {
            return '-'
          }
          return new Date(time).formatByTime()
        }
      },
    },
    watch: {
      nowUnit (nv,ov) {
        billStore.commit('setNowUnit',nv)
        this.getDataList(nv)
      },
      ownerName (nv,ov) {
        this.searchChange=true
      },
      state (nv,ov) {
        this.searchChange=true
      },
      filterTime (nv,ov) {
        this.searchChange=true
      },
      nowTimeInterval (nv,ov) {
        this.searchChange=true
        this.getDataList()
      }
    },
    methods: {
      //当前页
      pageindexChange (val) {
        this.pageIndex=val;
        this.getDataList()
      },
      //页大小
      handleSizeChange (val) {
        this.pageSize=val;
        this.pageIndex=1;
        this.getDataList()
      },
      editMeterRunType (row,column) {
        return row.meterRunType==1? '预付费表':'远控表';
      },
      editAccountType (row,column) {
        let accountType=''
        switch(row.accountType) {
          case '0':
            accountType='月结'
            break;
          case '1':
            accountType='预付费'
            break;
          case '2':
            accountType='预付费-月账单'
            break;
          default:
            accountType=''
            break;
        }
        return accountType
      },
      editMoneyYan (a) {
        return (a/100).toFixed(2)
      },
      selectState (item) {
        if(item.value==-3) {
          this.state=undefined
        } else {
          this.state=item.value
        }
      },
      selectAccountType (item) {
        this.accountType=item.value
      },
      selectMeterRunType (item) {
        this.meterRunType=item.value
      },
      //结算
      onOffState (item) {
        if(isNaN(parseInt(item.state))) {
          return
        }
        this.$refs.billDialog.open(data => {
          this.$api.meterReadingApi.manualClearing(item.pkid,data.fee*100,data.password,respon => {
            this.$dialogMethod.showMessage('操作成功')
            this.getDataList()
          },err => {
            this.$dialogMethod.showMessage(err)
          })
        })
      },

      //账单详情页面
      viewOrderDetails (e) {
        this.$router.push({
          name: 'orderDetailListReport',
          query:
          {
            userId: e.targetId,
            meterType: this.meterType,
            meterRunType: this.meterRunType,
            accountType: this.accountType,
            datetimeValue: this.datetimeValue,
            billingMode: e.billingMode
          }

        })
      },

      openOwnerInfoViewDialog (userData) {
        ownerManagerStore.state.nowOwnerInformation=userData
        this.$router.push('/ownerManagerView')
      },
      //排序
      compare (name) {
        return function(a,b) {
          var s1=a[name]+"";
          var s2=b[name]+"";
          return s1.localeCompare(s2);
        }
      },
      // 获取列表信息
      getDataList () {
        $(".typechoice").css("color","black");
        if(isempty(this.nowUnit)) {
          return
        }
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        if(isempty(this.accountType)||isempty(this.meterRunType)) {
          this.$dialogMethod.showMessage("需选择电表类型与付费类型!")
          $(".typechoice").css("color","red");
          return false
        }
        if(this.searchChange) {
          this.pageIndex=1
          this.searchChange=false
        }
        this.loading=true
        this.$api.meterReadingApi.getHandleElectricityBill(this.meterType,this.nowUnit.id,this.pageIndex,this.pageSize,this.deviceNos,this.ownerName,this.state,this.datetimeValue[0],this.datetimeValue[1],this.accountType,this.meterRunType,respon => {
          this.loading=false;
          this.dataList=copy(respon.dataList.sort(this.compare('createTime')))
          for(var i=0;i<respon.dataList.length;i++) {
            this.dataList[i]['Time']=this.timeText(respon.dataList[i].beginTime)+' - '+this.timeText(respon.dataList[i].endTime)
          }
          this.totalSize=respon.total

        })
      },
      // 导出报表
      exportReport () {
        if(isempty(this.datetimeValue)) {
          this.datetimeValue=['','']
        }
        var title=this.nowUnit.name+'账单信息'
        this.$store.cacheStore.state.load=true
        this.$api.meterReadingApi.exportElectricityBill(this.meterRunType,this.meterType,this.nowUnit.id,this.deviceNos,this.ownerName,this.state,this.datetimeValue[0],this.datetimeValue[1],this.accountType,respon => {
          saveAs(DWSystemSetting.downloadUrl+'/'+respon,title+".xls")
          this.$store.cacheStore.state.load=false
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .searchContainer {
    padding: 10px 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .searchContainer>div {
    display: inline-flex;
    flex-wrap: wrap;
    align-items: center;
    flex-grow: 0;
  }

  .searchContainer label {
    margin-right: 6px;
  }

  /deep/.el-input__inner {
    height: 32px;
    line-height: 32px;
  }

  .searchContainer input {
    border-color: #DCDFE6;
    min-width: 130px;
    height: 36px;
    box-sizing: border-box;
    margin-right: 10px;
  }

  .searchContainer>>>.selection-body {
    display: inline-flex;
    padding: 0;
    margin-right: 20px;
  }

  .searchContainer>>>.selection>p {
    line-height: 34px;
    height: 34px;
    padding: 0;
  }

  .selectDateTime {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 176px;
    height: 34px;
    padding: 0 6px;
    background: #FFFFFF;
    border-radius: 6px;
    border: solid 1px #DCDFE6;
    margin-right: 20px;
  }

  .selectDateTime>span {
    width: 140px;
    line-height: 34px;
    height: 100%;
    cursor: pointer;
  }

  .selectDateTime>img {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }

  .searchContainer>button {
    height: 36px;
    background-color: #409EFF;
    color: #FFFFFF;
    padding: 0 18px;
    margin-left: 10px;
    border-radius: 4px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .infoListContainer {
    padding: 0 20px 0 20px;
    height: calc(100% - 76px);
  }

  .infoListContainer::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  .infoListContainer::-webkit-scrollbar-track {
    box-shadow: none;
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: #F0F0F0;
  }

  .infoListContainer::-webkit-scrollbar-thumb {
    background-color: #FFFFFF;
  }

  .infoListContainer:hover::-webkit-scrollbar-thumb {
    background-color: #CACACA;
  }

  .infoListContainer>div {
    width: calc(100% - 10px);
  }

  .normalStatus {
    display: inline-block;
    border: solid 1px #87CF64;
    border-radius: 4px;
    color: #87CF64;
    background-color: #F0F9EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .wrongStatus {
    display: inline-block;
    border: solid 1px #F9A6A6;
    border-radius: 4px;
    color: #F9A6A6;
    background-color: #FEF1F1;
    line-height: 28px;
    padding: 0 6px;
  }

  .waitStatus {
    display: inline-block;
    border: solid 1px #E6A23C;
    border-radius: 4px;
    color: #E6A23C;
    background-color: #FDF6EC;
    line-height: 28px;
    padding: 0 6px;
  }

  .normalStatus:hover,
  .wrongStatus:hover,
  .waitStatus:hover {
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
  }

  .operateBtn {
    display: inline-block;
    border-radius: 4px;
    line-height: 28px;
    padding: 0 6px;
    background: #ECF5FF;
    color: #409EFF;
    border: solid 1px #409EFF;
    margin-right: 8px;
    cursor: pointer;
  }

  .noDrop {
    cursor: no-drop !important;
  }

  .marginRightNone {
    margin-right: 0;
  }

  @media screen and (max-width: 1600px) {
    .searchContainer label {
      display: block;
      margin-right: 0;
    }

    .infoListContainer {
      height: calc(100% - 96px);
    }
  }
</style>